"use client";

import styles from "./AuthorizeGoogleButton.module.scss";
import { setGoogleAuthLoading } from "@/stores";
import { useGoogleLogin } from "@react-oauth/google";
import { GoogleIcon } from "@/components";
import { useGoogleAuth } from "@/hooks";
import { isGoogleOAuthConfigured } from "@/constants";
import { useAuthorizeForm } from "../../_hooks";

/**
 * Active Google button — only mounted when OAuth client ID is configured
 * (useGoogleLogin requires GoogleOAuthProvider).
 */
const AuthorizeGoogleButtonActive = () => {
  const googleAuthState = useGoogleAuth();
  const { submitGoogleAuthorize } = useAuthorizeForm();

  const googleLogin = useGoogleLogin({
    onSuccess: async ({ code }) => {
      await submitGoogleAuthorize(code);
    },
    flow: "auth-code",
  });

  const handleFormSubmit = () => {
    setGoogleAuthLoading(true);
    googleLogin();
  };

  return (
    <div className={styles["comp"]} onClick={handleFormSubmit}>
      {!googleAuthState.loading && (
        <div className={styles["comp__content"]}>
          <GoogleIcon />
          <div className={styles["comp__label"]}>Continue with Google</div>
        </div>
      )}

      {googleAuthState.loading && (
        <div className={styles["comp__content"]}>
          <div className={styles["comp__loading"]} />
          <div className={styles["comp__label"]}>Authorizing...</div>
        </div>
      )}
    </div>
  );
};

export const AuthorizeGoogleButton = () => {
  if (!isGoogleOAuthConfigured()) return null;
  return <AuthorizeGoogleButtonActive />;
};
